import { GeofencesCreatePage, GeofencesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { generatePath } from '@/services/router/generate-path';

function GeofencesCreateRoute() {
  return (
    <GeofencesRoute
      permission="journeys/geofences/create"
      redirectTo={(params) =>
        generatePath('/workspaces/:workspaceId/geofences', { workspaceId: params.workspaceId ?? 0 })
      }
    >
      <GeofencesCreatePage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geofences/new')({
  component: GeofencesCreateRoute,
});
